import { render, staticRenderFns } from "./view.vue?vue&type=template&id=2e4b21a8&scoped=true&"
import script from "./view.vue?vue&type=script&lang=ts&"
export * from "./view.vue?vue&type=script&lang=ts&"
import style0 from "./view.vue?vue&type=style&index=0&id=2e4b21a8&scoped=true&lang=scss&"
import style1 from "./view.vue?vue&type=style&index=1&id=2e4b21a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b21a8",
  null
  
)

export default component.exports